import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../ycharts/static/ts/features/directives/popovers/popover/popover.directive";
const _c0 = ["ycn-news-ai-answer-source", ""];
const _c1 = () => ({ cursor: "pointer" });
const _c2 = () => ["popover"];
function NewsAIAnswerSourceComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 6);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r0.source.first_related_security == null ? null : ctx_r0.source.first_related_security.url, i0.ɵɵsanitizeUrl)("textContent", (ctx_r0.source.first_related_security == null ? null : ctx_r0.source.first_related_security.label) ?? "");
} }
function NewsAIAnswerSourceComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1, " +");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(6, _c1));
    i0.ɵɵproperty("tooltipClasses", i0.ɵɵpureFunction0(7, _c2))("tooltipPlacement", "top")("tooltipHtml", true)("tooltipTitle", ctx_r0.tooltipHtml);
} }
/**
 * News AI Answer Source Component
 *
 * Displays a single news article source for an AI answer.
 *
 * Input Properties:
 *  source: NewsChatAnswerSource with details of the article
 */
export class NewsAIAnswerSourceComponent {
    constructor() {
        this.tooltipHtml = '';
    }
    ngOnInit() {
        if (this.source?.additional_related_securities) {
            this.tooltipHtml = this.source.additional_related_securities
                .map((security) => {
                return `<a href="${security.url}" target="_blank">${security.label}</a>`;
            })
                .join(' ');
        }
    }
}
NewsAIAnswerSourceComponent.ɵfac = function NewsAIAnswerSourceComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NewsAIAnswerSourceComponent)(); };
NewsAIAnswerSourceComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NewsAIAnswerSourceComponent, selectors: [["tr", "ycn-news-ai-answer-source", ""]], inputs: { source: "source" }, standalone: false, attrs: _c0, decls: 8, vars: 6, consts: [[3, "textContent"], ["target", "_blank", 3, "href", "textContent", 4, "ngIf"], ["ycnPopover", "", 3, "style", "tooltipClasses", "tooltipPlacement", "tooltipHtml", "tooltipTitle", 4, "ngIf"], [1, "min-width-20", "max-width-220"], [1, "td-ellipsis", "max-width-full"], ["target", "_blank", 1, "td-ellipsis-content", 3, "href", "textContent"], ["target", "_blank", 3, "href", "textContent"], ["ycnPopover", "", 3, "tooltipClasses", "tooltipPlacement", "tooltipHtml", "tooltipTitle"]], template: function NewsAIAnswerSourceComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "td", 0);
        i0.ɵɵelementStart(1, "td");
        i0.ɵɵtemplate(2, NewsAIAnswerSourceComponent_a_2_Template, 1, 2, "a", 1)(3, NewsAIAnswerSourceComponent_span_3_Template, 2, 8, "span", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "td", 3)(5, "div", 4);
        i0.ɵɵelement(6, "a", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(7, "td", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("textContent", ctx.source.eastern_news_date_formatted);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.source.first_related_security);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.tooltipHtml);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("href", ctx.source.url, i0.ɵɵsanitizeUrl)("textContent", ctx.source.title);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", ctx.source.news_source);
    } }, dependencies: [i1.NgIf, i2.PopoverDirective], encapsulation: 2 });
